import { render } from "./GameResults.vue?vue&type=template&id=1e3a9467&scoped=true&bindings={\"playerIndex\":\"props\",\"playerReady\":\"data\",\"opponentReady\":\"options\",\"playerChecksReady\":\"options\",\"rematch\":\"options\",\"quit\":\"options\"}"
import script from "./GameResults.vue?vue&type=script&lang=js"
export * from "./GameResults.vue?vue&type=script&lang=js"

import "./GameResults.vue?vue&type=style&index=0&id=1e3a9467&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e3a9467"

export default script